// extracted by mini-css-extract-plugin
export var noSpinners = "_nl-6";
export var percentageInput = "_nl-7";
export var variantColor1 = "_nl-0";
export var variantColor2 = "_nl-1";
export var variantColor3 = "_nl-2";
export var variantColor4 = "_nl-3";
export var variantColor5 = "_nl-4";
export var variantColor6 = "_nl-5";